import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

/**
 * @typedef {Object} TabOption
 * @property {string} label
 * @property {string} value
 */

/**
 * @param {{
 *   tabs: TabOption[],
 *   value: string,
 *   onChange: (value: string) => void,
 * }} props
 */
export default function FilterTabs({ tabs, value, onChange }) {
  return (
    <Box
      sx={{ display: 'flex',
        gap: '4px',
        borderBottom: '1px solid var(--grey-200)',
        mb: 2,
      }}
    >
      {tabs.map((tab) => {
        const active = tab.value === value;
        return (
          <Box
            key={tab.value}
            onClick={() => onChange(tab.value)}
            sx={{ px: '16px',
              pt: '10px',
              pb: '14px',
              cursor: 'pointer',
              borderBottom: active ? '2px solid #009688' : '2px solid transparent',
              mb: '-1px',
            }}
          >
            <Typography
              sx={{ fontSize: '0.875rem',
                fontWeight: active ? 600 : 400,
                color: active ? '#009688' : 'var(--grey-600)',
                userSelect: 'none',
              }}
            >
              {tab.label}
            </Typography>
          </Box>
        );
      })}
    </Box>
  );
}
